import { ClientIntakeForm, IntakeFormStatus } from '@models/client-intake';
import { ClientIntakeFormStateModel } from './client-intake.state';

export function getMostRecentActiveForm(
	state: ClientIntakeFormStateModel,
): ClientIntakeForm | null {
	const activeForms =
		state?.items?.filter(
			(form) => form.status !== IntakeFormStatus.CANCELLED,
		) ?? [];

	if (!activeForms.length) return null;

	return activeForms.reduce((mostRecent, current) =>
		current.createdAt > mostRecent.createdAt ? current : mostRecent,
	);
}
